
import Gototop from "./Components/HomePage/Gototop";
import AllRoutes from "./Routes/AllRoutes";
import './index.css'
function App() {
  return (
    <div className="App">
      <AllRoutes />
      <Gototop/>
    </div>
  );
}

export default App;
